module.exports = __webpack_public_path__ + "static/media/gd.ef579aae.svg";